var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-iframe-container",style:({ height: _vm.winHeight + 'px' })},[(_vm.iframeUrl)?_c('iframe',{attrs:{"src":_vm.iframeUrl}}):_c('div',{staticClass:"chat-loading"},[_vm._v("Loading…")])])}
var staticRenderFns = []

export { render, staticRenderFns }